export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '考试等级',
    dataIndex: 'questions_Level_type',
    width: '240px'
  },
  {
    title: '题干',
    dataIndex: 'question',
    width: '600px'
  },
  {
    title: '难度',
    dataIndex: 'difficulty',
    scopedSlots: { customRender: 'difficulty' },
    width: '70px'
  },
  {
    title: '题目类型',
    dataIndex: 'type',
    width: '140px',
    customRender: (text, record, index) => {
      if (record.actualType === 0) {
        return '简答题';
      } else if (record.actualType === 1) {
        return '单选题';
      } else if (record.actualType === 2) {
        return '多选题';
      } else if (record.actualType === 3) {
        return '判断题';
      }
    },
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: '70px',
    customRender: (text, record, index) => {
      return record.status === 0 ? '禁用' : '启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '160px',
    scopedSlots: { customRender: 'operation' },
  },
];

export const columns1 = [
  {
    title: 'Excel行号',
    dataIndex: 'line',
    width: '80px',
    align: 'center'
  },
  {
    title: '题型',
    dataIndex: 'questionType',
    width: '5%'
  },
  {
    title: '题干',
    dataIndex: 'question',
    width: '20%'
  },
  {
    title: '答案',
    dataIndex: 'answer',
    width: '10%'
  },
  {
    title: '选项A',
    dataIndex: 'optiona',
    width: '6%'
  },
  {
    title: '选项B',
    dataIndex: 'optionb',
    width: '6%'
  },
  {
    title: '选项C',
    dataIndex: 'optionc',
    width: '6%'
  },
  {
    title: '选项D',
    dataIndex: 'optiond',
    width: '6%'
  },
  {
    title: '选项E',
    dataIndex: 'optione',
    width: '6%'
  },
  {
    title: '难度',
    dataIndex: 'difficulty',
    width: '5%'
  },
  {
    title: '一致性',
    dataIndex: 'uniformity',
    width: '7%'
  },
  {
    title: '反馈信息',
    dataIndex: 'error_msg',
    scopedSlots: { customRender: 'error_msg' },
    width: '20%'
  },
];